import createPersistedState from 'vuex-persistedstate';

export default ({ store }) => {
  createPersistedState({
    paths: ['authStore.lastOrgId', 'ampStore.recentlyViewedAmps', 'authStore.userData', 'builderStore.nodesClipboard'],
  })(store);
};
